import { useSelector, useDispatch } from 'react-redux';
import { setUser, updateUser, clearUser } from '../actions/userActions';
import { CookieNames, getCookie } from '../../helpers/cookie.helper';
import { getProfile } from '../../services/profile.service';
import { useAppContext } from '../../contexts/AppContext';
import { useCallback } from 'react';

/**
 * Custom hook to access and manage user state from Redux
 * @returns {Object} User state and action dispatchers
 */
export const useUser = () => {
  const { showLoader, hideLoader } = useAppContext();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const fetchUserProfile = async () => {
    try {
      showLoader();
      const res = await getProfile(getCookie(CookieNames.USER_ID));
      if (res.status === 200) {
        dispatch(setUser({...res.resultObject, isLoggedIn: true}));
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoader();
    }
  };

  const handleUpdateUser = useCallback((updates) => {
    dispatch(updateUser(updates));
  }, [user, dispatch, useSelector]);

  return {
    user,
    setUser: (userData) => dispatch(setUser(userData)),
    updateUser: handleUpdateUser,
    clearUser: () => dispatch(clearUser()),
    fetchUserProfile: fetchUserProfile,
  };
};
